export const GET_ALL_WAREHOUSES = 'GET_ALL_WAREHOUSES'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
